import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { CircularProgress, Typography } from "@mui/material";
import { useContextData } from "../hooks/useContextData";

type ProtectedRouteProps = {
  children: React.ReactNode;
};

const LoadingSpinner: React.FC = () => {
  const { userInfo, theme } = useContextData();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
        backgroundColor: theme === "dark" ? "#00050F" : "white",
        color: theme === "dark" ? "#FAFAFA" : undefined,
      }}
    >
      <Typography fontWeight={200}>Loading Facerevealer...</Typography>
      <CircularProgress sx={{ mt: 2 }} />
    </div>
  );
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

export default ProtectedRoute;
